module.exports = __webpack_public_path__ + "img/Phorto_1__People_&_Pleasures_984_102_1_Fortier_Family.95845bda.jpg";